export default {
  en: {
    translation: {
      domains: {
        investments: {
          investmentTable: {
            quote: "Quote",
            entries_one: "{{count}} entry",
            entries_other: "{{count}} entries",
            purchase: "Purchase Value",
            name: "Name",
            change: "Change",
            pieces: "Lots at",
            dividends: " Dividends",
            changePercentAbs: "Change",
            totalValue: "Total Value",
            dividendsValue: "Dividends",
            addQuote: {
              modalTitle: "Add quote",
              quote: "Quote",
              quote_withCurrency: "Quote ({{currency}})",
              quoteFrom: "Quote from",
              save: "Save",
              successMessage: "Successfully saved",
            },
            detailModal: {
              currentQuote: "Current quote",
              performanceToday: "Performance today",
              fundamentals: "Fundamentals",
              protocol: "Protocol",
              noBookings: "No bookings available",
              noPriceData: "No price data available",
              latestNews: "Latest News:",
              readMore: "Read more",
              readLess: "Read less",
              noNews: "No news available",
            },
            mobile: {
              settings: "Sort and view options",
              accept: "Accept",
              reset: "Reset",
              sortBy: "Sort by",
              view: "View",
              chipsSection: "Chips",
              sortOption: "{{field}}: {{direction}}",
              showChipLabels: "Show chip labels",
              ascendingText: "A to Z",
              descendingText: "Z to A",
              ascendingNumber: "Low to high",
              descendingNumber: "High to low",
              lastPrice: "Last price {{date}}",
              noPrice: "No price yet",
              addQuote: "Add quote",
              reorder:
                "Reorder {{field}}. Drag, or press Space and use the arrow keys.",
              fields: {
                name: "Name",
                isin: "ISIN",
                wkn: "WKN",
                today: "Change (today)",
                purchase: "Purchase value",
                total: "Change (total)",
                dividends: "Dividends",
              },
              chips: {
                today: "Today",
                purchase: "Purchase",
                total: "Total",
                dividends: "Dividends",
              },
            },
          },
        },
        dividends: {
          noDividends: "No dividends. Would you like to add manually?",
          noDividendsAddLink: "Add",
          addDividends: "Add manually",
          missingDividends: {
            header_one: "There is {{value}} missing dividend.",
            header_other: "There are {{value}} missing dividends.",
            addBatchButton: "Add now",
          },
          dividendsTable: {
            headers: {
              date: "Date",
              dividend: "Dividend",
              lots: "Lots",
              total: "Total",
              actions: "Actions",
            },
            actions: {
              addDividends: "Add",
              editDividends: "Edit",
            },
          },
        },
        bankSelect: {
          pageTitle: "Import portfolios/accounts",
          title: "Please search bank",
          searchLabel: "Bank Name, BIC or IBAN",
          selectBic: {
            title: "Please select BIC",
            back: "Back",
          },
          notFound: "Bank not found.",
          notSupported: "The bank is currently not supported.",
        },
        creditCardsMiniCard: {
          lastTransaction: "The last transaction",
          noTransactions: "No transactions",
        },
        creditCardCard: {
          title: "Credit cards",
          title_one: "{{count}} Credit card",
          title_other: "{{count}} Credit cards",
          noAccountsTitle: "No credit cards",
          noAccountsSubtitle:
            "You do not have any credit cards, do you want to add them now?",
          noAccountsButtonText: "Add now",
        },
        cashAccountsCard: {
          title: "Accounts",
          subtitle_one: "{{count}} Account",
          subtitle_other: "{{count}} Accounts",
          noAccountsTitle: "No accounts",
          noAccountsSubtitle:
            "You do not have any accounts, do you want to add them now?",
          noAccountsButtonText: "Add now",
          percentPrefix: "YTD:",
        },
        donutChart: {
          total: "Total",
        },
        depotsCard: {
          title: "Portfolios",
          depotsTitle_one: "{{count}} Portfolio",
          depotsTitle_other: "{{count}} Portfolios",
          noAccountsTitle: "No portfolios",
          noAccountsSubtitle:
            "You do not have any portfolios, do you want to add them now?",
          noAccountsButtonText: "Add now",
          addButton: "Add",
          addManuallyButton: "Manually",
        },
        accountPreviewCard: {
          updateRecommended: "Update recommended",
        },
        investmentsCard: {
          title: "Investments",
          subtitle_one: "{{count}} Investment",
          subtitle_other: "{{count}} Investments",
          noAccountsTitle: "No investments",
          noAccountsSubtitle:
            "You do not have any investments, do you want to add them now?",
          noAccountsButtonText: "Add now",
          percentPrefix: "YTD:",
        },
      },
      general: {
        chart: {
          assetsChart: {
            legend: {
              investments: "Investments",
              cash: "Cash",
              insurances: "Insurances",
            },
          },
          selectComparison: {
            compareWith: "Compare with",
            recommends: "Recommendations",
            markets: "Markets",
          },
          securitiesChart: {
            assetTypes: {
              all: "All",
              derivative: "Derivative",
              etfs: "ETFs",
              funds: "Funds",
              bonds: "Bonds",
              holdings: "Holdings",
              crypto: "Crypto",
            },
            securitiesChartBottomBar: {
              typeSwitcher: {
                performance: "Performance",
                valuation: "Valuation",
                disabledTooltip:
                  "Comparison is only supported in mode ‘performance’",
              },
            },
            mobileHeaderValues: {
              all: "All",
              holdings: "Holdings",
              funds: "Funds",
              etfs: "ETFs",
              derivative: "Derivative",
              bonds: "Bonds",
              crypto: "Crypto",
            },
          },
        },
        ranges: {
          rangeSelector: {
            intervalSelector: {
              compact: {
                oneDay: "1D",
                oneWeek: "1W",
                oneMonth: "1M",
                sixMonths: "6M",
                oneYear: "1Y",
                threeYears: "3Y",
                fiveYears: "5Y",
                YTD: "YTD",
                sinceBeginning: "Max",
                all: "All",
              },
              customLength: {
                days: "{{count}}D",
                weeks: "{{count}}W",
                months: "{{count}}M",
                years: "{{count}}Y",
              },
              oneWeek: "1 week",
              oneMonth: "1 month",
              oneYear: "1 year",
              sinceBeginning: "Since the beginning",
            },
          },
        },
        table: {
          tableMobileSortMenu: {
            sortBy: "Sort by",
          },
        },
      },
    },
  },
  de: {
    translation: {
      domains: {
        investments: {
          investmentTable: {
            quote: "Kurs",
            entries_one: "{{count}} Eintrag",
            entries_other: "{{count}} Einträge",
            purchase: "Kaufwert",
            name: "Name",
            change: "Änderung",
            pieces: "St. zu",
            dividends: " Dividende",
            changePercentAbs: "Änderung",
            totalValue: "Gesamtwert",
            dividendsValue: "Dividende",
            addQuote: {
              modalTitle: "Kurs hinzufügen",
              quote: "Kurs",
              quote_withCurrency: "Kurs ({{currency}})",
              quoteFrom: "Kurs vom",
              save: "Speichern",
              successMessage: "Erfolgreich gespeichert",
            },
            detailModal: {
              currentQuote: "Aktueller Kurs",
              performanceToday: "Performance heute",
              fundamentals: "Fundamentaldaten",
              protocol: "Protokoll",
              noBookings: "Keine Buchungen vorhanden",
              noPriceData: "Keine Kursdaten",
              latestNews: "Letzte News:",
              readMore: "Mehr lesen",
              readLess: "Weniger anzeigen",
              noNews: "Keine News verfügbar",
            },
            mobile: {
              settings: "Sortierung und Ansicht",
              accept: "Übernehmen",
              reset: "Zurücksetzen",
              sortBy: "Sortieren nach",
              view: "Ansicht",
              chipsSection: "Chips",
              sortOption: "{{field}}: {{direction}}",
              showChipLabels: "Chip-Beschriftungen anzeigen",
              ascendingText: "A bis Z",
              descendingText: "Z bis A",
              ascendingNumber: "Aufsteigend",
              descendingNumber: "Absteigend",
              lastPrice: "Letzter Kurs {{date}}",
              noPrice: "Noch kein Kurs",
              addQuote: "Kurs hinzufügen",
              reorder:
                "{{field}} verschieben. Ziehen, oder Leertaste und Pfeiltasten verwenden.",
              fields: {
                name: "Name",
                isin: "ISIN",
                wkn: "WKN",
                today: "Änderung (heute)",
                purchase: "Kaufwert",
                total: "Änderung (gesamt)",
                dividends: "Dividenden",
              },
              chips: {
                today: "Heute",
                purchase: "Kauf",
                total: "Gesamt",
                dividends: "Dividende",
              },
            },
          },
        },
        dividends: {
          noDividends:
            "Keine Dividenden. Möchten Sie einen Eintrag hinzufügen?",
          noDividendsAddLink: "Hinzufügen",
          addDividends: "Manueller Eintrag",
          missingDividends: {
            header_one: "{{value}} fehlende Dividende.",
            header_other: "{{value}} fehlende Dividenden.",
            addBatchButton: "Jetzt hinzufügen",
          },
          dividendsTable: {
            headers: {
              date: "Datum",
              dividend: "Dividende",
              lots: "Stück",
              total: "Gesamt",
              actions: "Aktion",
            },
            actions: {
              addDividends: "Hinzufügen",
              editDividends: "Bearbeiten",
            },
          },
        },
        bankSelect: {
          pageTitle: "Depots/Konten importieren",
          title: "Bitte wählen Sie Ihre Bank",
          searchLabel: "IBAN, BLZ, BIC oder Name",
          selectBic: {
            title: "Bitte wählen Sie Ihre BIC",
            back: "Zurück",
          },
          notFound: "Nicht gefunden",
          notSupported: "Diese Bank wird aktuell noch nicht unterstützt",
        },
        creditCardsMiniCard: {
          lastTransaction: "Letzte Buchung",
          noTransactions: "Keine Buchungen",
        },
        creditCardCard: {
          title: "Kreditkarten",
          title_one: "{{count}} Kreditkarte",
          title_other: "{{count}} Kreditkarten",
          noAccountsTitle: "Keine Kreditkarten",
          noAccountsSubtitle:
            "Sie haben bisher noch keine Kreditkarten hinzugefügt, möchten Sie das jetzt tun?",
          noAccountsButtonText: "Kreditkarten hinzufügen",
        },
        cashAccountsCard: {
          title: "Konten",
          subtitle_one: "{{count}} Konto",
          subtitle_other: "{{count}} Konten",
          noAccountsTitle: "Keine Konten",
          noAccountsSubtitle:
            "Sie haben bisher noch keine Konten hinzugefügt, möchten Sie das jetzt tun?",
          noAccountsButtonText: "Konten hinzufügen",
          percentPrefix: "YTD:",
        },
        donutChart: {
          total: "Gesamtausgaben",
        },
        depotsCard: {
          title: "Depots",
          depotsTitle_one: "{{count}} Depot",
          depotsTitle_other: "{{count}} Depots",
          noAccountsTitle: "Keine Konten",
          noAccountsSubtitle:
            "Sie haben bisher noch keine Konten hinzugefügt, möchten Sie das jetzt tun?",
          noAccountsButtonText: "Konten hinzufügen",
          addButton: "Hinzufügen",
          addManuallyButton: "Manuell",
        },
        accountPreviewCard: {
          updateRecommended: "Aktualisierung empfohlen",
        },
        investmentsCard: {
          title: "Investments",
          subtitle_one: "{{count}} Investment",
          subtitle_other: "{{count}} Investments",
          noAccountsTitle: "Keine Investments",
          noAccountsSubtitle:
            "Sie haben bisher noch keine Investments hinzugefügt, möchten Sie das jetzt tun?",
          noAccountsButtonText: "Investments hinzufügen",
          percentPrefix: "YTD:",
        },
      },
      general: {
        chart: {
          assetsChart: {
            legend: {
              investments: "Investments",
              cash: "Cash",
              insurances: "Versicherungen",
            },
          },
          selectComparison: {
            compareWith: "Vergleichen mit",
            recommends: "VORSCHLÄGE",
            markets: "MÄRKTE",
          },
          securitiesChart: {
            assetTypes: {
              all: "Alle",
              derivative: "Derivate",
              etfs: "ETF",
              funds: "Fonds",
              bonds: "Anleihen",
              holdings: "Einzeltitel",
              crypto: "Krypto",
            },
            securitiesChartBottomBar: {
              typeSwitcher: {
                performance: "Performance",
                valuation: "Wert",
                disabledTooltip:
                  "Ein Vergleich der Werte kann nur im Modus ‘Performance’ vorgenommen werden",
              },
            },
            mobileHeaderValues: {
              all: "Alle",
              holdings: "Einzeltitel",
              funds: "Fonds",
              etfs: "ETF",
              derivative: "Derivate",
              bonds: "Anleihen",
              crypto: "Krypto",
            },
          },
        },
        ranges: {
          rangeSelector: {
            intervalSelector: {
              compact: {
                oneDay: "1D",
                oneWeek: "1W",
                oneMonth: "1M",
                sixMonths: "6M",
                oneYear: "1J",
                threeYears: "3J",
                fiveYears: "5J",
                YTD: "YTD",
                sinceBeginning: "Max",
                all: "All",
              },
              customLength: {
                days: "{{count}}D",
                weeks: "{{count}}W",
                months: "{{count}}M",
                years: "{{count}}J",
              },
              oneWeek: "1 Woche",
              oneMonth: "1 Monat",
              oneYear: "1 Jahr",
              sinceBeginning: "Seit Beginn",
            },
          },
        },
        table: {
          tableMobileSortMenu: {
            sortBy: "Sortieren nach",
          },
        },
      },
    },
  },
};
